export const initCategoryDropdown = (): void => {
  const dropdowns = document.querySelectorAll<HTMLElement>(
    "[data-category-dropdown]",
  );

  if (dropdowns.length === 0) return;

  dropdowns.forEach((dropdown) => {
    const trigger = dropdown.querySelector<HTMLButtonElement>(
      "[data-dropdown-trigger]",
    );
    const list = dropdown.querySelector<HTMLElement>("[data-dropdown-list]");

    if (!trigger || !list) return;

    const toggle = (state?: boolean) => {
      const isOpen = state ?? !dropdown.classList.contains("is-open");
      dropdown.classList.toggle("is-open", isOpen);
      trigger.setAttribute("aria-expanded", String(isOpen));
      list.setAttribute("aria-hidden", String(!isOpen));
    };

    trigger.addEventListener("click", (e) => {
      e.stopPropagation();
      toggle();
    });

    // Dışarı tıklandığında menüyü kapat
    document.addEventListener("click", (e) => {
      if (!dropdown.contains(e.target as Node)) {
        toggle(false);
      }
    });

    // ESC tuşuna basıldığında menüyü kapat
    document.addEventListener("keydown", (e) => {
      if (e.key === "Escape" && dropdown.classList.contains("is-open")) {
        toggle(false);
        trigger.focus();
      }
    });
  });
};
